import {ExRateInfo} from "./features/cards/ExRateInfo";
import {OrderStatus} from "./features/cards/OrderStatus";
import {useReadDashboardSetting} from "./hooks/useReadDashboardSetting";
import {
    dashboardBarChartDataMapInit,
    dashboardDoughnutChartDataMapInit,
    dashboardSettingListMapInit,
    dashboardSettingSearchParamInit
} from "./state";
import {
    DashboardBarChartDataMapType,
    DashboardDoughnutChartDataMapType,
    DashboardSettingListElementType
} from "./interface";
import {useReadRevenueByHandlerByYear} from "./hooks/useReadRevenueByHandlerByYear";
import {useReadRevenueByHandlerByMonth} from "./hooks/useReadRevenueByHandlerByMonth";
import {useReadRevenueByItem} from "./hooks/useReadRevenueByItem";
import {useReadRevenueByTeamByMonth} from "./hooks/useReadRevenueByTeamByMonth";
import {useReadRevenueByTeamByQuarter} from "./hooks/useReadRevenueByTeamByQuarter";
import {useReadRevenueByTeamByYear} from "./hooks/useReadRevenueByTeamByYear";
import {useReadRevenueByUserByLastYear} from "./hooks/useReadRevenueByUserByLastYear";
import {useReadRevenueByUserByMonth} from "./hooks/useReadRevenueByUserByMonth";
import {useReadRevenueByUserByYear} from "./hooks/useReadRevenueByUserByYear";
import {useReadRevenueByVertical} from "./hooks/useReadRevenueByVertical";
import DoughnutChartCard from "./features/cards/DoughnutChartCard";
import BarChartCard from "./features/cards/BarChartCard";
import {useUser} from "../../../../util/userContext/UserContext";
import {useReadRevenueByTeamByLastYear} from "./hooks/useReadRevenueByTeamByLastYear";

export const Dashboard = () => {
    const {user} = useUser()
    const {data: dashboardSettingApiData} = useReadDashboardSetting({
        param: {
            ...dashboardSettingSearchParamInit,
            paginationFlag: "N"
        }
    });
    const dashboardSetting = dashboardSettingApiData ?? dashboardSettingListMapInit
    const cardData: DashboardSettingListElementType[] = dashboardSetting.dashboardInfoVOList ?? []

    const {data: revenueByItemData} = useReadRevenueByItem()
    const {data: revenueByVerticalData} = useReadRevenueByVertical()
    const {data: revenueByTeamByQuarterData} = useReadRevenueByTeamByQuarter()
    const {data: revenueByTeamByLastYearData} = useReadRevenueByTeamByLastYear()
    const {data: revenueByTeamByYearData} = useReadRevenueByTeamByYear()
    const {data: revenueByTeamByMonthData} = useReadRevenueByTeamByMonth()
    const {data: revenueByHandlerByMonthData} = useReadRevenueByHandlerByMonth()
    const {data: revenueByHandlerByYearData} = useReadRevenueByHandlerByYear()
    const {data: revenueByUserByMonthData} = useReadRevenueByUserByMonth()
    const {data: revenueByUserByLastYearData} = useReadRevenueByUserByLastYear()
    const {data: revenueByUserByYearData} = useReadRevenueByUserByYear()

    const cardRenderer = () => {
        const chunkedCard: DashboardSettingListElementType[][] = [];

        for (let i = 0; i < cardData.length; i += 3) {
            chunkedCard.push(cardData
                .sort((a, b) => a.dashboardOrder - b.dashboardOrder)
                .filter(el => el.isHidden === "N").slice(i, i + 3));
        }

        return <>
            {chunkedCard.map(el =>
                <div className="row gx-3 mb-15px">
                    {el.map((el2, idx) =>
                        <div className="col-4">
                            {(() => {
                                let titleKeyword = "";
                                let title = "";
                                let data;

                                switch (el2.infoIndex) {
                                    case 1:
                                        titleKeyword = "아이템"
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByItemData ?? dashboardDoughnutChartDataMapInit) as DashboardDoughnutChartDataMapType

                                        return <DoughnutChartCard titleKeyword={titleKeyword}
                                                                  title={title} data={data} item={el2}/>
                                    case  2:
                                        titleKeyword = "Vertical"
                                        title = el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByVerticalData ?? dashboardDoughnutChartDataMapInit) as DashboardDoughnutChartDataMapType

                                        return <DoughnutChartCard titleKeyword={titleKeyword}
                                                                  title={title} data={data} item={el2}/>
                                    case  3:
                                        titleKeyword = user?.teamName ?? ""
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByTeamByQuarterData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    case  4:
                                        titleKeyword = user?.teamName ?? ""
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByTeamByLastYearData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    case  5:
                                        titleKeyword = user?.teamName ?? ""
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByTeamByYearData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    case  6:
                                        titleKeyword = user?.teamName ?? ""
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByTeamByMonthData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    case  7:
                                        titleKeyword = "담당자"
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByHandlerByMonthData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    case  8:
                                        titleKeyword = "담당자"
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByHandlerByYearData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    case  9:
                                        titleKeyword = user?.userName ?? ""
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByUserByMonthData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    case 10:
                                        titleKeyword = user?.userName ?? ""
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByUserByLastYearData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    case 11:
                                        titleKeyword = user?.userName ?? ""
                                        title = " " + el2.reportName.replace(titleKeyword, "")
                                        data = (revenueByUserByYearData ?? dashboardBarChartDataMapInit) as DashboardBarChartDataMapType

                                        return <BarChartCard titleKeyword={titleKeyword}
                                                             title={title} data={data} item={el2}/>
                                    default:
                                        return <></>
                                }
                            })()}
                        </div>
                    )}
                </div>
            )}
        </>
    }

    return (
        <>
            <div className="row gx-3 mb-15px">
                <div className="col-6">
                    <OrderStatus/>
                </div>
                <div className="col-6">
                    <ExRateInfo/>
                </div>
            </div>

            {cardRenderer()}
        </>
    );
}